import React from "react";
import moment from "moment";

const AttendanceSheet = ({ rows,  project }) => {
    return (
        <div className="table-responsive">
            <h4 className="text-center mb-3">
                {project?.PROJECT_NAME} - Timesheet
            </h4>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>S/No</th>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Date Attribute</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Actual Attendance</th>
                        <th>OT</th>
                        <th>Remark</th>
                    </tr>
                </thead>
                <tbody>
                    {rows?.length > 0 ? (
                        rows.map((row, idx) => (
                            <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td>{row.FULL_NAME}</td>
                                <td>{moment(row.DATE).format("DD-MMM-YY")}</td>
                                <td>{row.DATE_ATTRIBUTE}</td>
                                <td>{row.TIME_FROM || ""}</td>
                                <td>{row.TIME_TO || ""}</td>
                                <td>{row.ACTUAL_ATTENDANCE || ""}</td>
                                <td>{row.OT || ""}</td>
                                <td>{row.REMARK || ""}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="10" className="text-center text-muted">
                                No attendance found for this month
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default AttendanceSheet;
